import React from 'react';

import { ReactComponent as UnassignFromCollectionIcon} from "static/icons/minus-circle.svg";

import { unassignFromCollection } from "../../store/actions/collections";

import UniversalButton from "../uiComponents/UniversalButton";
import {useDispatch, useSelector} from "react-redux";

const UnassignFromCollection = ({tableInfo, deleteSelectElements}) => {

  const dispatch = useDispatch();
  const { tabs } = useSelector((state) => state.table);

  const handleClickButton = async () => {
    await dispatch(unassignFromCollection({...tableInfo, tabs}));
    deleteSelectElements();
  }

  return (
    <>
      <UniversalButton
        style={{height: '32px'}}
        label="Unassign from selection set"
        size="md"
        labelColor="blue"
        labelHoverColor="blue"
        backgroundColor="blue"
        backgroundHoverColor="$blue"
        leftIcon={<UnassignFromCollectionIcon />}
        onClick={handleClickButton}
        isRounded="sm"
      />
    </>
  );
};

export default UnassignFromCollection;